// Copyright © 2022 Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const buildContentTitle = (title: string, page = 1): string => {
  const pageAdjunct = page > 1 ? `- strona ${page}` : ''
  return `${title} ${pageAdjunct}`
}
